import { render, staticRenderFns } from "./customizechinamap.vue?vue&type=template&id=6f763405&scoped=true"
import script from "./customizechinamap.vue?vue&type=script&lang=js"
export * from "./customizechinamap.vue?vue&type=script&lang=js"
import style0 from "./customizechinamap.vue?vue&type=style&index=0&id=6f763405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f763405",
  null
  
)

export default component.exports